import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil';
import { currentPlayer } from '../atom/atoms';

const styles = {
    leaderBoard: {
        "padding": "40px",
        "background-image": "linear-gradient(#ff005a,#e0004f)",
        "width": "1000px",
        "border-radius": "20px",
        "margin": "20px",
        "box-shadow": "rgb(0 0 0 / 15%) -1px 1px 11px 11px"
    },
    home: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "center",
        "font-size": "xx-large",
        "font-weight": "bold",
    },
    input: {
        "width": "300px",
        "height": "50px",
        "font-size": "xx-large",
        "margin": "20px",
        "border-radius": "10px",
    },
    nameGroup: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "center",
    },
    score: {
        "display": "flex",
        "justify-content": "space-between",
    }
}

const Home = () => {
    const [name, setName] = useRecoilState(currentPlayer);
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem('leaderBoard')) {
            localStorage.setItem('leaderBoard', JSON.stringify([]));
        }
    }, []);

    const leaderBoard = JSON.parse(localStorage.getItem('leaderBoard'));

    return (
        <div style={styles.home}>
            <h1 style={{ "color": "yellow", "textShadow": "2px 2px #ff0000" }}>Frontend Warrior</h1>
            Leader board
            <div style={styles.leaderBoard}>
                {leaderBoard?.map((element, index) => <div style={styles.score}>
                    <div key={element.id}>{index + 1}. {element.name}</div>
                    <div>{element.score}</div>
                </div>)}
            </div>
            <div style={styles.nameGroup}>
                Enter name to start the game
                <div>Name: <input style={styles.input} value={name} onChange={(e) => setName(e.target.value)} />
                    <button onClick={() => { navigate("/game") }}>
                        Start
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Home